import type { FormField, FormStep } from '@cli-types/core-engine/schema.js'

export function getStepFieldNames(step: FormStep): string[] {
  const names: string[] = []
  const collect = (fields: FormField[]): void => {
    for (const field of fields) {
      if (field.hidden) continue
      if (field.type === 'dynamicFields') continue
      if (field.type === 'group' && field.fields) {
        collect(field.fields)
      } else if (field.name) {
        names.push(field.name)
      }
    }
  }
  collect(step.fields)
  return names
}
